import React, { useState } from "react";
import { Team } from "../../models/Team";
import { UpcomingMatch } from "../../models/UpcomingMatch";
import styles from "./modal.module.css";
import { createUpcomingMatch, deleteUpcomingMatch, updateUpcomingMatch } from "../../services/MatchService";

interface EditUpcomingMatchModalProps {
    match: UpcomingMatch | null;
    teams: Team[];
    onClose: () => void;
}

const EditUpcomingMatchModal: React.FC<EditUpcomingMatchModalProps> = ({ match, teams, onClose }) => {
    const [team1, setTeam1] = useState<Team | null>(match?.team1 || null);
    const [team2, setTeam2] = useState<Team | null>(match?.team2 || null);
    const [matchTime, setMatchTime] = useState<string | null>(match?.match_time || new Date().toISOString());
    const [division, setDivision] = useState<string>(match?.division || "");
    const [roundNumber, setRoundNumber] = useState<number | null>(match?.roundNumber || null);
    const [playoffPlayed, setPlayoffPlayed] = useState<boolean>(match?.playoffPlayed || false);
    const [status, setStatus] = useState<string | null>(null)

    const handleSave = async () => {
        const isPlayoff = division.toLowerCase() === "upper" || division.toLowerCase() === "lower" || division.toLowerCase() === "final";

        console.log(matchTime, team1, team2, division, isPlayoff, roundNumber, playoffPlayed);
        if (!matchTime || !team1 || !team2) {
            return;
        }

        const newRoundNumber = isPlayoff ? roundNumber : null;

        // Create a new UpcomingMatch object with the updated values
        const updatedMatch = new UpcomingMatch(crypto.randomUUID(), team1, team2, matchTime, division, "temp", isPlayoff, newRoundNumber, playoffPlayed);
        try {
            if (match === null) {
                await createUpcomingMatch(updatedMatch);
            }
            else {
                updatedMatch.challonge_id = match.challonge_id;
                await updateUpcomingMatch(updatedMatch);
            }
            setStatus("Kamp gemt")
        }
        catch (error) {
            setStatus("Fejl ved oprettelse af kamp")
        }
        onClose();
    };

    const handleDelete = async () => {
        if (match === null) {
            return;
        }
        await deleteUpcomingMatch(match.challonge_id);
        onClose();
    };

    return (
        <div className={styles.modal}>
            <div className={styles["modal-content"]}>
                <h2>Edit Upcoming Match</h2>
                <div>
                    <label>Team 1:</label>
                    <select
                        value={team1?.teamId || ""}
                        onChange={(e) => {
                            const selectedTeam = teams.find((team) => team.teamId === e.target.value);
                            setTeam1(selectedTeam || null);
                        }}
                    >
                        <option value="" disabled>
                            Select a team
                        </option>
                        {teams.map((team) => (
                            <option key={team.teamId} value={team.teamId}>
                                {team.teamName}
                            </option>
                        ))}
                    </select>
                </div>
                <div>
                    <label>Team 2:</label>
                    <select
                        value={team2?.teamId || ""}
                        onChange={(e) => {
                            const selectedTeam = teams.find((team) => team.teamId === e.target.value);
                            setTeam2(selectedTeam || null);
                        }}
                    >
                        <option value="" disabled>
                            Select a team
                        </option>
                        {teams.map((team) => (
                            <option key={team.teamId} value={team.teamId}>
                                {team.teamName}
                            </option>
                        ))}
                    </select>
                </div>
                <div>
                    <label>Match Time:</label>
                    <div>
                        <input
                            type="date"
                            value={matchTime ? new Date(matchTime).toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10)}
                            onChange={(e) => {
                                const updatedDate = new Date(matchTime || new Date());
                                const [year, month, day] = e.target.value.split("-");
                                updatedDate.setFullYear(Number(year));
                                updatedDate.setMonth(Number(month) - 1); // Month is 0-indexed
                                updatedDate.setDate(Number(day));
                                setMatchTime(updatedDate.toISOString());
                            }}
                        />
                        <input
                            type="time"
                            value={matchTime ? new Date(matchTime).toISOString().slice(11, 16) : new Date().toISOString().slice(11, 16)}
                            onChange={(e) => {
                                const updatedTime = new Date(matchTime || new Date());
                                const [hours, minutes] = e.target.value.split(":");
                                updatedTime.setHours(Number(hours));
                                updatedTime.setMinutes(Number(minutes));
                                updatedTime.setSeconds(0); // Optional: Reset seconds to zero
                                updatedTime.setMilliseconds(0); // Optional: Reset milliseconds to zero
                                setMatchTime(updatedTime.toISOString());
                            }}
                        />
                    </div>
                </div>
                <div>
                    <label>Gruppe/Playoff</label>
                    <input type="text" value={division} onChange={(e) => setDivision(e.target.value)} />
                    {/* make text black */}
                    <p className="text-black">Playoff skal være "upper", "lower" eller "final". "final" skal kun bruges i grand final kampen.</p>
                </div>
                <div>
                    <label>Runde (kun hvis playoff)</label>
                    <input type="text" value={roundNumber ?? ""} onChange={(e) => setRoundNumber(Number.parseInt(e.target.value))} />
                </div>
                <div>
                    <label>Er playoff spillet?</label>
                    <input type="checkbox" checked={playoffPlayed} onChange={(e) => setPlayoffPlayed(e.target.checked)} />
                </div>
                {
                    status && <div>{status}</div>
                }
                <div className={styles["modal-actions"]}>
                    <button onClick={onClose}>Cancel</button>
                    {
                        match !== null && (
                            <>
                                <button className="btn btn-danger" onClick={handleDelete}>Delete</button>
                            </>
                        )
                    }
                    <button className="btn btn-secondary" onClick={handleSave}>Save</button>
                </div>
            </div>
        </div>
    );
};

export default EditUpcomingMatchModal;
